module.exports = __webpack_public_path__ + "img/039ce27c80b90f8f8352a22553e80521.png";